export enum ArticleType {
    UNDEFINED = 0,
    CALENDAR = 1,
    NEWS = 2,
    LFM_NEWS = 3,
    PAGE = 4
}